import {
	createElement,
	createElementNS,
	query,
	queryAll,
	getCursorPoint,
	setProps,
	hasClass,
	addClass,
	removeClass,
} from "../utils.js";

class MaskedButton {
	btn;
	point;
	lerpPoint;
	running;
	inertia = 0.1;

	constructor(el) {
		this.btn = el;
		this.btn.addEventListener("mouseenter", this.enterHandler);
	}

	reset = () => {
		this.point = this.lerpPoint = null;
		this.running = false;
	};

	enterHandler = (e) => {
		const el = e.target;
		const container = el;
		const svg = query(".u-svg", el);

		// if (!svg) {
		// 	const clone = hasClass(el, 'clone');
		// 	const index = maskBts.indexOf(el);
		// 	const maskId = `circle_mask_${index}`;
		// 	const circle_1 = createElementNS('circle');
		// 	const svg = createElementNS('svg');

		// 	if (clone) {
		// 		const clipPath = createElementNS('clipPath', { id: maskId });
		// 		clipPath.appendChild(circle_1);
		// 		svg.appendChild(clipPath);
		// 	} else svg.appendChild(circle_1);

		// 	el.appendChild(svg);

		// 	if (container && clone) {
		// 		const style = `clip-path: url(#${maskId});`;
		// 		const cloneContainer = createElement('div', { class: 'clone-container', style: style });
		// 		const containerClone = container.cloneNode(true);
		// 		cloneContainer.appendChild(containerClone);
		// 		el.appendChild(cloneContainer);
		// 	}
		// }

		el.addEventListener("mousemove", this.moveHandler);
		el.addEventListener("mouseleave", this.leaveHandler, { once: true });

		const r = Math.hypot(el.clientWidth, el.clientHeight);
		setProps(el, { "--r": `${r}px` });

		const circle = query("circle", el);
		circle.removeEventListener("transitionend", this.reset);

		this.moveHandler(e);
		if (!this.running) {
			this.running = true;
			this.render();
		}
		addClass(el, "hover");
	};

	moveHandler = (e) => {
		this.point = getCursorPoint(e);
		if (!this.lerpPoint) this.lerpPoint = this.point;
	};

	leaveHandler = (e) => {
		const el = e.target;
		const circle = query("circle", el);
		setProps(el, { "--r": `0px` });
		el.removeEventListener("mousemove", this.moveHandler);
		circle.addEventListener("transitionend", this.reset);
		removeClass(el, "hover");
	};

	render = () => {
		if (this.running) {
			this.lerpPoint.x += (this.point.x - this.lerpPoint.x) * this.inertia;
			this.lerpPoint.y += (this.point.y - this.lerpPoint.y) * this.inertia;
			setProps(this.btn, {
				"--x": `${this.lerpPoint.x}px`,
				"--y": `${this.lerpPoint.y}px`,
			});
			requestAnimationFrame(this.render);
		}
	};
}

export { MaskedButton };
